
document.addEventListener('DOMContentLoaded', function() {

  // Script pour convertir le menu en hover plutôt qu'en click
  const detailsElements = document.querySelectorAll('header-menu details');
  
  detailsElements.forEach(details => {
    // Ouvrir au survol
    details.addEventListener('mouseenter', function() {
      this.setAttribute('open', true);
    });
    
    // Fermer quand la souris quitte
    details.addEventListener('mouseleave', function() {
      this.removeAttribute('open');
    });
    
    // Modifier le comportement du clic sur summary
    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function(e) {
        // Vérifier si le clic était sur un lien à l'intérieur du summary
        const clickedElement = e.target.closest('a');
        
        // Si c'est un lien, ne pas empêcher l'action par défaut
        if (!clickedElement) {
          // Si le clic n'était pas sur un lien, empêcher l'action par défaut (ouverture/fermeture)
          e.preventDefault();
        }
      });
    }
  });




  // Sélectionner tous les éléments avec la classe .parallax-container
  const parallaxContainers = document.querySelectorAll('.parallax-container');
  let ticking = false;
  
  // Fonction pour initialiser les valeurs de base
  function initParallax() {
    parallaxContainers.forEach(container => {
      // Récupérer la valeur de --parallax-base-y depuis le CSS propre à chaque élément
      const computedStyle = window.getComputedStyle(container);
      let cssBaseValue = computedStyle.getPropertyValue('--parallax-base-y').trim();
      
      // Vérifier si la valeur existe et la valider
      if (!cssBaseValue) {
        cssBaseValue = '-400px'; // Valeur par défaut
      }
      
      // Convertir en nombre (enlever "px" ou autres unités)
      const numericValue = cssBaseValue.replace(/px|rem|em|vh|vw|%/g, '').trim();
      const baseTranslateY = parseFloat(numericValue);
      
      // Stocker la valeur de base propre à chaque élément directement comme attribut
      container.setAttribute('data-base-translate-y', baseTranslateY);
      
      // Log pour debugging
      console.log('Élément initialisé:', container);
      console.log('Valeur CSS --parallax-base-y:', cssBaseValue);
      console.log('Valeur numérique stockée:', baseTranslateY);
    });
    
    // Exécuter le parallaxe initial
    updateParallax();
  }
  
  // Fonction pour appliquer l'effet de parallaxe
  function updateParallax() {
    // Pour chaque conteneur de parallaxe
    parallaxContainers.forEach(container => {
      // Récupérer l'intensité propre à chaque élément ou utiliser la valeur par défaut
      const intensity = container.hasAttribute('data-parallax-intensity') 
        ? parseFloat(container.getAttribute('data-parallax-intensity')) 
        : 0.1;
      
      // Récupérer la valeur de base propre à chaque élément
      const baseTranslateY = container.hasAttribute('data-base-translate-y')
        ? parseFloat(container.getAttribute('data-base-translate-y'))
        : -400; // Valeur par défaut si non définie
      
      // Calculer la position de l'élément
      const rect = container.getBoundingClientRect();
      const centerPosition = rect.top + rect.height / 2;
      
      // Calculer la position relative
      const windowCenter = window.innerHeight / 2;
      const distanceFromCenter = centerPosition - windowCenter;
      
      // Calculer le facteur de déplacement à partir de la valeur de base propre à l'élément
      const translateY = baseTranslateY - (distanceFromCenter * intensity);
      
      // Appliquer la transformation propre à chaque élément
      container.style.setProperty('--parallax-translate-y', `${translateY}px`);
    });
    
    ticking = false;
  }
  
  // Gestionnaire d'événement de défilement avec throttling
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }
  
  // Ajouter les écouteurs d'événements
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleScroll, { passive: true });
  
  // Initialiser au chargement de la page
  document.addEventListener('DOMContentLoaded', initParallax);
  
  // Exécuter également au chargement complet de la page pour être sûr
  window.addEventListener('load', initParallax);







  // Effet de parallax pour .shopify-section.liens svg
  (function() {
    // Fonction auto-exécutée pour isoler le scope
    
    // Fonction d'initialisation du parallax
    function initParallax() {
      // Sélectionner l'élément SVG
      const svgElement = document.querySelector('.shopify-section.liens svg');
      
      // Si l'élément n'existe pas, on ne fait rien et on sort de la fonction
      if (!svgElement) {
        return;
      }
      
      // Paramètres de parallax
      const parallaxIntensity = 0.08;
      
      // Fonction pour mettre à jour la position du SVG
      function updateParallaxPosition() {
        const scrollPosition = window.scrollY;
        const offset = scrollPosition * parallaxIntensity;
        svgElement.style.transform = `translateY(${offset}px)`;
      }
      
      // Ajouter l'écouteur d'événement pour le défilement
      window.addEventListener('scroll', updateParallaxPosition);
      
      // Initialiser la position
      updateParallaxPosition();
    }
    
    // S'assurer que le DOM est chargé avant d'initialiser
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }
  })();

  
});